import { Order } from './order';
import { Organization } from './organization';
import { User } from './user';

export type MillingJobType = {
    _id?: string;
    name: string;
    materials: string[] | MillingMaterial[];
};

export type MillingMaterial = {
    _id?: string;
    additionalColors: string[];
    name: string;
    useVitaColors: boolean;
};

export type MillingJob = {
    _id?: string;
    jobType: string;
    material: string;
    color?: string;
    filename: string;
    order: Order;
    status: MillingJobStatus;
    createdAt: Date;
    createdBy: User;
    organization: Organization;
    originalMillingJob?: MillingJob;
    copyReason: MillingJobCopyReason;
    files: File[];
    zipFileKey: string;
    stlFiles: { url: string; filename: string }[] | [];
    deadline: Date | null;
    comment: string;
};

export enum MillingJobStatus {
    PROCESSING_FILES = 'PROCESSING_FILES',
    CREATED = 'CREATED',
    IN_PRODUCTION = 'IN_PRODUCTION',
    FINISHED = 'FINISHED',
    REDONE = 'REDONE',
}

export type MillingFilters = {
    jobType?: string;
    material?: string;
    color?: string;
};

export type MillingBatch = {
    _id?: string;
    jobType: string;
    material: string;
    color: string;
    status: MillingBatchStatus;
    createdAt: Date;
    createdBy: User;
    organization: Organization;
    millingJobs: MillingJob[];
    redoMillingJobs?: MillingJob[];
    orders: Order[];
    batchNumber?: string;
    zipFileKey: string;
};

export enum MillingBatchStatus {
    IN_PRODUCTION = 'IN_PRODUCTION',
    FINISHED = 'FINISHED',
}

export enum MillingJobCopyReason {
    NONE = 'NONE',
    REDO = 'REDO',
    WARRANTY = 'WARRANTY',
}
